module.exports = __webpack_public_path__ + "static/cablemitts-a7d2186f3e76ba54ee2d2556dad2dfed.jpeg";